/**
 * Trạng thái ký số
 */
export default {
  /**
   * Chờ ký
   */
  Pending: 0,

  /**
   * Đang ký
   */
  Signing: 1,

  /**
   * Hoàn thành
   */
  Completed: 2,

  /**
   * Từ chối
   */
  Rejected: 3,

  /**
   * Chưa gửi ký (thu hồi người cần ký đưa về trạng thái này)
   */
  NotSent: 4,
};
